export function replaceLocation(path: string): void {
  window.location.replace(path);
}
